angular.module('lsnBase.deepExtend', []);